import { connect } from "react-redux";
import OrganizationUtils from "../../../utils/organization";
import {
  SuspendUserModalDataProps,
  SuspendUserModalProps as _SuspendUserModalProps,
} from "./suspend-user-modal-view";
import { AppState } from "../../../store/AppState";
import {
  PickReduxDispatchProps,
  PickReduxStateProps,
} from "../../../util/typeUtil";
import { clearError, getUser, setUserSuspended } from "../../../actions";
import { ActionSender } from "../../../model/ActionSender";
import { addSenderArgument } from "../../../actions/actionHelpers";
import SuspendUserModal from "./suspend-user-modal-container";
import InProgressUtils from "../../../utils/in-progress";
import UserUtils, { UserWithStatus } from "../../../utils/user";
import AuthenticationUtils from "../../../utils/authentication";

export interface SuspendUserModalProps
  extends Omit<_SuspendUserModalProps, keyof SuspendUserModalDataProps> {
  // for some reason in this case the omit does not remove all keys with keyof  RemoveGroupModalDataProps like it does
  // elsewhere. So far I have not been able to figure out a way to inspect/debug what is actually there to be removed.
}
// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<
  _SuspendUserModalProps,
  SuspendUserModalProps
>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _SuspendUserModalProps,
  SuspendUserModalProps
>;

const sender: ActionSender = { key: "suspend-user" };

function mapStateToProps(
  state: AppState,
  ownProps: SuspendUserModalProps
): ReduxStateProps {
  const user = ownProps.userId
    ? OrganizationUtils.selectOrganizationUser(ownProps.userId, state)
    : undefined;
  let userWithExtra: UserWithStatus | undefined = undefined;
  if (user) {
    userWithExtra = UserUtils.userWithStatus({
      ...user,
    });
  }
  return {
    isReady: InProgressUtils.selectNotInProgress(sender.key, state),
    actorId: AuthenticationUtils.selectAuthenticationUserId(state) as string,
    user: userWithExtra,
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    InProgressUtils.compareInProgressStates(next, prev) &&
    AuthenticationUtils.compareAuthenticationUserIdStates(next, prev) &&
    OrganizationUtils.compareOrganizationUsersStates(next, prev)
  );
}
const dispatchActions: ReduxDispatchProps = {
  onSuspendUser: (id: string) => setUserSuspended(sender, true, id) as any,
  onLoadUser: addSenderArgument(sender, getUser),
  onClearError: clearError,
};

export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  SuspendUserModalProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual,
})(SuspendUserModal);
